import { render, staticRenderFns } from "./DashHome.vue?vue&type=template&id=38f6770c&"
import script from "./DashHome.vue?vue&type=script&lang=js&"
export * from "./DashHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports